import type { App } from "vue";
import {
  OrganizationDataSourceImpl,
  organizationDataSourceKey,
} from "./data/datasources/organization_datasource";
import {
  PartnershipDataSourceImpl,
  partnershipDataSourceKey,
} from "./data/datasources/partnership_datasource";

export function initOrganizationModule(app: App) {
  app.provide(organizationDataSourceKey, new OrganizationDataSourceImpl());
  app.provide(partnershipDataSourceKey, new PartnershipDataSourceImpl());
}
